import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { UserService } from 'src/app/core/services/user.service';
import { ICase } from '../../interfaces/case.interface';
import { SuccessComponent } from 'src/app/components/shared/components/success/success.component';
import { CasesService } from 'src/app/core/services/cases.service';
import { UnitsService } from 'src/app/core/services/units.service';
import { IUser } from 'src/app/core/interfaces/user.interface';
import { ICaseType } from 'src/app/modules/case-types/interfaces/case-type.interface';
import { AlertService } from 'src/app/modules/case-new-view/alert.service';

@Component({
  selector: 'app-proceed-case',
  templateUrl: './proceed-case.component.html',
  styleUrls: ['./proceed-case.component.scss'],
})
export class ProceedCaseComponent implements OnInit {
  aditionalInfoForm: any;
  form = this.fb.group({
    assigned: ['', [Validators.required]],
    category: [
      { value: 'Transferencia Mismo Banco', disabled: true },
      [, Validators.required],
    ],
    type: ['', [Validators.required]],
    subType: ['', [Validators.required]],
    // status: ['', [ Validators.required]],
    reason: [''],
    description: [''],
    caseType: [''],
  });
  users: IUser[] = [];
  caseTypes: ICaseType[] = [];
  categoryExample = ['Transferencia Mismo Banco'];
  subTypeExample = [
    'Transferencias Atípica',

    'Transferencias a Beneficiarios sospechoso',

    'Operaciones realizadas fuera del horario usual',

    'Monto de Transferencias irregular',

    'Tiempo limite entre múltiples transacciones',
    // 'No Reconocidos Comporta. Fraude',
    // 'Comportamiento Fraude Tdd',
    // 'Comportamiento Fraude Tcp',
    // 'Movimiento Con Tarjeta No Recibida',
    // 'Usurpacion De Identidad Tdd',
    // 'Retiros De Efectivo Por Taquilla',
    // 'Comportamiento Fraude Mala Asociacion',
    // 'Movimiento Con Tarjeta No Recibida',
    // 'Comportamiento Fraude Tcp',
    // 'Forjado / Alterado',
    // 'Duplicado',
    // 'Robo / Hurto / Extravio',
    // 'No Reconocidos Comporta. Fraude',
    // 'Operac De Fraudes',
    // 'Comportamiento Fraude',
    // 'Movimiento Con Tarjeta No Recibida',
    // 'Retiros De Efectivo Por Taquilla',
    // 'Uso Indebido Sin Responsabilidad',
    // 'Uso Indebido Con Responsabilidad',
  ];
  typeExample = [
    'Operación Via BT EnLinea',

    'Operación Via APP',
    // 'Estafa En Agencia Por Tercero',
    // 'Deposito No Abonado',
    // 'Reclamo Por Inconformidad En Consumos',
    // 'Usurpación De Identidad',
    // 'Debito No Reconocido En Cta.',
    // 'Crédito No Reconocido',
    // 'Transacción No Ejecutada',
    // 'Tarjeta Robada',
    // 'Tarjeta Extraviada',
    // 'Sustitución De Tarjeta',
    // 'Vulneración De Cuenta',
  ];
  status = [
    {
      status: 'Procede',
      value: 'proceed',
    },
    {
      status: 'No procede',
      value: 'refused',
    },
    {
      status: 'Sin asignar',
      value: 'initial',
    },
  ];
  case: any = {};
  isLoading = false;

  constructor(
    private readonly casesService: CasesService,
    public readonly userService: UserService,
    private readonly fb: FormBuilder,
    private readonly dialog: MatDialog,
    private readonly dialogRef: MatDialogRef<ProceedCaseComponent>,
    private readonly unitsService: UnitsService,
    private readonly alertService: AlertService,

    @Inject(MAT_DIALOG_DATA)
    public data: {
      alert: any;
    }
  ) {}

  ngOnInit() {
    if (this.data.alert) {
      this.form.patchValue(this.data.alert);
      this.form.controls.assigned.setValue(
        this.data.alert.assigned ? this.data.alert.assigned._id : undefined
      );

      this.aditionalInfoForm = this.data.alert;
    }

    this.getCaseTypes();
  }

  getCaseTypes() {
    this.unitsService.getTypeCases(this.data.alert.unit).subscribe({
      next: (caseTypes: any) => {
        this.caseTypes = caseTypes;
        this.case.caseType = caseTypes[0]._id;
        this.findUser();
      },
    });
  }

  async findUser() {
    let caseType = this.caseTypes.find(
      (item: any) => item._id == this.case.caseType
    );
    const roles = caseType.role;
    console.log(roles);
    const users: IUser[] = [];

    for (const role of roles) {
      const usersByRole = await this.userService
        .getUsersByRole(role)
        .toPromise();
      console.log(usersByRole);
      users.push(...usersByRole);
    }

    this.users = users;
  }

  alert(title: string) {
    this.dialog.open(SuccessComponent, {
      data: { title },
    });
  }

  save() {
    this.isLoading = true;
    const data: any = this.data.alert;
    data.user_changing = this.userService.currentUser._id;

    // 🔧 FIX: Clean alert data before updating to prevent MongoDB CastError
    let alertUpdated = this.cleanAlertData(this.data.alert);
    // alertUpdated.status = this.form.value.status;
    alertUpdated.status = 'assigned';
    alertUpdated.assigned = this.form.value.assigned;
    alertUpdated.category = this.form.value.category;
    alertUpdated.type = this.form.value.type;
    alertUpdated.subType = this.form.value.subType;

    let alert;
    this.alertService.updateAlert(this.data.alert._id, alertUpdated).subscribe({
      next: (alertUpdate) => {
        this.alert('Alerta asignada');
        this.alertService.alertEdited.next(alertUpdate);
        alert = alertUpdate;
      },
    });

    let creator = this.userService.currentUser._id;

    // 🔧 FIX: Clean additionalInformation to prevent MongoDB CastError
    this.case.additionalInformation = this.cleanAlertData(this.data.alert);
    this.case.creator = creator;
    this.case.status = 'assigned';
    this.case.files = [];
    this.case.gai = alertUpdated.gai;
    this.case.description = this.data.alert.descripcion;
    this.case.additionalInformation.monto_salio = this.data.alert.monto_salio;
    this.case.assigned = this.form.value.assigned;
    this.case.additionalInformation.category = this.form.value.category;
    this.case.additionalInformation.subCategory = this.form.value.subCategory;
    this.case.additionalInformation.type = this.form.value.type;
    this.case.alert = this.data.alert._id;
    this.case.toAssignedAt = new Date();
    if (!alertUpdated.wasRejectedAssigned && this.data.alert.code == '02') {
      this.casesService.create(this.case).subscribe({
        next: async (caseCreated: any) => {
          this.isLoading = false;
          this.alert('Alerta tipificada con éxito');
          this.dialogRef.close({ updated: true, alert, case: caseCreated });
        },
        error: (err) => {
          console.log(err);

          this.alert(err.error);
          this.isLoading = false;
        },
      });
    } else if (
      alertUpdated.wasRejectedAssigned &&
      this.data.alert.code == '02'
    ) {
      this.case.user_changing = this.userService.currentUser._id;
      this.casesService.update(this.data.alert.case._id, this.case).subscribe(
        (res) => {
          this.alert('Alerta tipificada con éxito');
          this.dialogRef.close({ updated: true, alert, case: res });
        },
        (error) => {
          console.log('An error occurred:', error);
        }
      );
    }
  }

  changeproceed() {
    if (this.form.value.status == 'refused') {
      this.form.get('reason').setValidators([Validators.required]);
      this.form.get('assigned').setValidators([]);
    } else if (this.form.value.status == 'proceed') {
      this.form.get('reason').setValidators([]);
      this.form.get('assigned').setValidators([Validators.required]);
    }
    this.form.get('reason').updateValueAndValidity();
    this.form.get('assigned').updateValueAndValidity();
  }

  closeModal() {
    this.dialogRef.close();
  }

  /**
   * 🔧 Helper function to clean invalid ObjectId fields from alert data
   * This prevents MongoDB CastError when trying to save empty objects as ObjectIds
   */
  private cleanAlertData(alertData: any): any {
    const cleaned = { ...alertData };

    // Clean the 'case' field if it's an empty object or invalid
    if (
      cleaned.case &&
      typeof cleaned.case === 'object' &&
      Object.keys(cleaned.case).length === 0
    ) {
      delete cleaned.case;
      console.log('🔧 Removed empty case object from alert data');
    } else if (
      cleaned.case &&
      typeof cleaned.case === 'string' &&
      cleaned.case.trim() === ''
    ) {
      delete cleaned.case;
      console.log('🔧 Removed empty case string from alert data');
    }

    // Add more field validations here if needed in the future
    // Example: clean other ObjectId fields that might be problematic

    return cleaned;
  }
}
